import { Component } from '@angular/core';
import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';

import { Field } from '../../models/field.interface';
import { FieldConfig } from '../../models/field-config.interface';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-form-select',
  styleUrls: ['form-select.component.scss'],
  templateUrl: './form-select.component.html',
  imports: [CommonModule, FormsModule, ReactiveFormsModule],
})
export class FormSelectComponent implements Field {
  config: FieldConfig;
  group: FormGroup;
}
